import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiCheckDoubleFill, RiCheckFill} from "react-icons/ri";
import PuffLoader from "react-spinners/PuffLoader";
import axios from "axios";
import {getGroupMessagesRoute} from "../../utils/apiRoutes";
import {setAlert} from "../../Redux/actions/alertAction";

const ChatGroupRoom = ({user, selectedGroup, socket, setAlert}) => {
    const [messages, setMessages] = useState(null);
    const [arrivalMessageState, setArrivalMessageState] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const scrollToBottom = (smooth) => {
        setTimeout(() => {
                const section = document.querySelector('#messagesEnd');
                section.scrollIntoView({behavior: `${smooth ? 'smooth' : 'auto'}`, block: 'end'});
            }
            , 0);
    }

    useEffect(() => {
        async function fetchData() {
            if (selectedGroup) {
                setIsLoading(true)
                getGroupsMessages();
                setIsLoading(false)
                scrollToBottom(false);
            }
        }

        fetchData();
    }, [selectedGroup]);

    const getGroupsMessages = async () => {
        try {
            const res = await axios.get(getGroupMessagesRoute + "/" + selectedGroup.id);
            setMessages(res.data);
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    useEffect(() => {
        if (socket.current) {
            socket.current.on("msg-receive", (data) => {
                if (!!data)
                    setArrivalMessageState(data)
            });
        }
    });

    useEffect(() => {
        if (arrivalMessageState && arrivalMessageState.to === selectedGroup.id)
            setArrivalMessage({
                fromSelf: user.id === arrivalMessageState.from,
                senderName: arrivalMessageState.senderName,
                message: arrivalMessageState.message,
                date: arrivalMessageState.date,
                time: arrivalMessageState.time
            });
    }, [arrivalMessageState, selectedGroup.id]);

    const setArrivalMessage = (newMessage) => {
        const allMessages = [...messages, newMessage];
        setMessages(allMessages);
    }

    useEffect(() => {
        scrollToBottom(true);
    }, [messages]);

    return (
        <Container>
            <div className="chat-messages" id='messagesEnd'>
                {isLoading || !messages ?
                    <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                    :
                    messages.map((message, index, array) => {
                        return (
                            <div key={index}>
                                {
                                    index === 0 || array[index - 1].date !== message.date
                                        ?
                                        <div className='date-container'>
                                            {
                                                message.date === new Date().getFullYear() + '-'
                                                + (new Date().getMonth().toString().length === 1 ? ('0' + (new Date().getMonth()+1)) : (new Date().getMonth()+1)) + '-'
                                                + (new Date().getDate().toString().length === 1 ? ('0' + new Date().getDate()) : new Date().getDate())
                                                    ? <p>Today</p>
                                                    : <p>{message.date}</p>
                                            }
                                        </div>
                                        : null}
                                <div
                                    className={`message ${
                                        message.fromSelf ? "sended" : "recieved"
                                    }`}
                                >
                                    <div className="content ">
                                        {message.fromSelf ? null :
                                            <h5 className="msg-time"
                                                style={{fontStyle: 'italic', fontSize: '0.8rem'}}>{message.senderName}</h5>
                                        }
                                        <span style={{whiteSpace: "pre-wrap"}}>{message.message}</span>
                                        <div className="msg-time">
                                            {message.is_read ? <RiCheckDoubleFill/> : <RiCheckFill/>}
                                            <p>{message.time}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </Container>
    );
}

ChatGroupRoom.propTypes = {
    selectedGroup: PropTypes.object,
    socket: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    selectedGroup: state.contact.selectedGroup,
    setAlert: PropTypes.func.isRequired,
    socket: state.auth.socket,
    user: state.auth.user
});

export default connect(mapStateToProps, {setAlert})(ChatGroupRoom);

const Container = styled.div`
  overflow-y: auto;
  z-index: 1;
  background: white;

  &::-webkit-scrollbar {
    width: 0.5rem;

    &-thumb {
      background-color: #D1D6DB;
      width: 0.1rem;
      border-radius: 1rem;
    }
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }

  .chat-messages {
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .message {
      display: flex;
      align-items: center;

      .content {
        max-width: 40%;
        overflow-wrap: break-word;
        padding: 1rem;
        font-size: 1.1rem;
        border-radius: 0.5rem;
        @media screen and (min-width: 720px) and (max-width: 1080px) {
          max-width: 70%;
        }
      }
    }

    .sended {
      justify-content: flex-end;

      .content {
        background-color: #F5F7FB;
      }
    }

    .recieved {
      justify-content: flex-start;

      .content {
        background-color: #7269EF;
        color: white;
      }
    }

    .msg-time {
      display: flex;
      gap: 3px;
      color: #B2B4F6;
      font-size: 12px;
      font-weight: 500;
      margin-top: 5px;
    }

    .date-container {
      position: relative;
      height: 1px;
      background-color: #F0EFF5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 15px;

      p {
        background-color: #F0EFF5;
        border-radius: 0.25rem;
        padding: 5px 10px;
        font-size: 0.80rem;
      }
    }
  }
`;